import React, { useEffect, useState } from 'react'
import DropDown from '../../sharedComponents/DropDown'
import { ILanguageContent } from '../../models'

function MenuLang({ languageItems }: { languageItems: ILanguageContent[] }) {
  const [language, setLanguage] = useState(languageItems[0])

  useEffect(() => {
    const route = location.pathname
    languageItems.forEach((item) => {
      if (route.includes(item.Url)) {
        setLanguage(item)
      }
    })
  }, [])

  const handleSelect = (language: ILanguageContent) => {
    window.location.href = language.Url
  }

  return (
    <div className="z-40 leading-[1]">
      <DropDown
        items={languageItems}
        selectedItem={language}
        handleSelect={handleSelect}
      />
    </div>
  )
}

export default MenuLang
